var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-popup",
    {
      staticClass: "popup",
      attrs: { "get-container": "body", "close-on-popstate": "" },
      model: {
        value: _vm.getShow,
        callback: function($$v) {
          _vm.getShow = $$v
        },
        expression: "getShow"
      }
    },
    [
      _c("div", { staticClass: "popup-container" }, [
        _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
        _c("img", {
          staticClass: "close-img",
          attrs: {
            src: require("@/assets/imgs/common/close-popup.png"),
            alt: ""
          },
          on: {
            click: function($event) {
              return _vm.$emit("update:show", false)
            }
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }